/**
 * Ref-counted scroll lock for overlays/modals.
 *
 * Multiple components can independently lock/unlock body scroll without
 * interfering with each other. Scroll is only re-enabled when ALL locks
 * are released. Prevents the bug where closing one overlay restores
 * scrolling while another overlay is still open.
 */

let lockCount = 0;

export function lockScroll(): void {
    lockCount++;
    if (lockCount === 1) {
        document.body.style.overflow = "hidden";
    }
}

export function unlockScroll(): void {
    lockCount = Math.max(0, lockCount - 1);
    if (lockCount === 0) {
        document.body.style.overflow = "";
    }
}
